import React, {ReactElement} from "react";
import {Service} from "./Service";
import classes from './Services.module.scss'
import {faDocker} from "@fortawesome/free-brands-svg-icons";
import {
	faCamera,
	faGlobe,
	faHome,
	faNetworkWired,
	faPencilRuler,
	faServer,
	faUserFriends
} from "@fortawesome/pro-solid-svg-icons";

const Services = (): ReactElement => {
	return (
		<div className={classes.root}>
			<h2>Co nabízím</h2>
			<div className={classes.container}>
				<Service
					icon={faGlobe}
					header='Vývoj webu'
					description='Prezentační webová stránka dle vašich požadavků kompatibilní na všech zařízeních'
				/>
				<Service
					icon={faDocker}
					header='Webové aplikace'
					description='Vývoj systému, který zjednoduší průběh vaší práce a ušestří drahocený čas'
				/>
				<Service
					icon={faHome}
					header='Chytrá domácnost'
					description='Instalace a konfigurace inteligentní domácnosti přímo vám na míru'
				/>
				<Service
					icon={faNetworkWired}
					header='Správa sítí'
					description='Návrh, instalace a diagnostika malých a středních sítí'
				/>
				<Service
					icon={faServer}
					header='Správa serverů'
					description='Profesionální administrace a zaručený chod vašeho serveru'
				/>
				<Service
					icon={faCamera}
					header='Produktové foto'
					description='Atraktivní fotografie vašeho produktu'
				/>
				<Service
					icon={faUserFriends}
					header='IT konzultace'
					description='Pomoc s velkou škálou IT problémů (sestavení/oprava PC, návrh serverů)'
				/>
				<Service
					icon={faPencilRuler}
					header='Vývoj na míru'
					description='Řešení vašich unikátních požadavků na míru'
				/>
			</div>
		</div>
	)
}

export default Services
